import { isReadOnlyGroups } from "./permissions";
import useAuth from "./useAuth";

export const useReadOnlyUser = () => {
  const { profile } = useAuth();
  return isReadOnlyGroups(profile.groups);
};
